export function formatNumber(value: number, digits = 3, locale = "de-DE") {
  if (!Number.isFinite(value)) {
    return "-";
  }

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: digits,
    minimumFractionDigits: 0
  }).format(value);
}
